import { Injectable } from '@angular/core';
import { ApiCommon } from '@shared/apis/common';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PortalApi extends ApiCommon {

  sendAccessCode(query): Observable<any> {
    const { ticketNo, secret } = query;
    return this.apiServer.portal.sendAccessCode(ticketNo, secret);
  }

  issueToken(ticketNo, secret, accessCode): Observable<any> {
    return this.apiServer.portal.issueToken(ticketNo, secret, accessCode);
  }

  portalTicket(ticketNo, token): Observable<any> {
    return this.apiServer.portal.portalTicket(ticketNo, token);
  }

  cancelRequest(ticketNo, token): Observable<any> {
    return this.apiServer.portal.cancelRequest(ticketNo, token);
  }

  creditCardPayment(data, token): Observable<any> {
    return this.apiServer.portal.creditCardPayment(data, token);
  }
}
